export default IconMath1Divide3 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-math-1-divide-3" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M10 15.5a.5 .5 0 0 1 .5 -.5h2a1.5 1.5 0 0 1 0 3h-1.167h1.167a1.5 1.5 0 0 1 0 3h-2a.5 .5 0 0 1 -.5 -.5" />
  <path d="M5 12h14" />
  <path d="M10 5l2 -2v6" />
</svg>`;